export class GridColumnMasterAPIModel {
  GetGridcolumndata: any;
  GetGriddeailsAPI: any;
  GetGridcolumndataApi: any;
  GetGroupbydetails: any;


}
